<template>
  <td class="sticky-column">
    <a @click.prevent="downloadFile({ fileUrl: fileData.download_url, fileName: fileData.file_name })" target="_blank">
      {{ fileData.file_name }}
    </a>
  </td>
  <td>
    <div>{{ fileData.file_description }}</div>
  </td>
  <td>
    <div>{{ fileData.file_type }}</div>
  </td>
  <td>
    <div>{{ formatFileSize(fileData.file_size) }}</div>
  </td>
  <td>
    <div>{{ fileData.upload_time }}</div>
  </td>
  <td
    v-if="getAccessType == 'manager' || getAccessType == 'vet'"
    :class="{ 'inactive-status': fileData.status === $t('FilesData.TK_Inactive') }"
  >
    <div>{{ fileData.status }}</div>
  </td>
  <td
    v-if="getAccessType == 'manager'"
    :class="{ 'inactive-status': fileData.status === $t('FilesData.TK_Inactive') }"
  >
    <div>{{ fileData.status_date }}</div>
  </td>
  <td>
    <div class="is-flex is-justify-content-start" style="gap: 1em;">
      <div v-if="editingAppointment &&
                 (getAccessType == 'manager' || getAccessType == 'vet' || fileData.file_id == 0) &&
                 fileData.status != $t('FilesData.TK_Inactive')">
        <button
          type="button"
          class="button is-danger is-small"
          @click="remove(fileData, $t)">
          {{ $t('General.Delete') }}
        </button>
      </div>
      <div v-if="editingAppointment &&
                 (getAccessType == 'manager' || getAccessType == 'vet' || fileData.file_id == 0) &&
                 fileData.status != $t('FilesData.TK_Active')">
        <button
          type="button"
          class="button is-danger is-small"
          @click="reactivate(fileData, $t)">
          {{ $t('General.Reactivate') }}
        </button>
      </div>
    </div>
  </td>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters, mapActions } from "vuex";
import { Notyf } from "notyf";

const notyf = new Notyf();

export default defineComponent({
  name: "AppointmentDataFileTableRow",

  props: {
    fileData: {
      type: Object,
      required: true
    }
  },

  computed: {
    ...mapGetters([
      "getEditingAppointment",
      "getAccessType",
      "getEditedAppointmentFiles"
    ]),

    editingAppointment(): boolean {
      return this.getEditingAppointment;
    }
  },

  methods: {
    ...mapActions([
      "downloadFile",
      "saveFileToBeDeleted",
      "removeFileEditedAppointment",
      "saveFileToBeReactivated",
      "reactivateFileEditedAppointment"
    ]),

    async remove(fileData: any, $t: any) {
      if (confirm( $t('FilesData.ConfirmDeleteFile'))) {
        if (fileData.file_id !== 0) {
          await this.saveFileToBeDeleted(fileData.file_id);
        }
        try {
          //await this.removeFileEditedAppointment(fileData.file_pos);
          await this.removeFileEditedAppointment({file_pos: fileData.file_pos, file_id: fileData.file_id, status: $t('FilesData.TK_Inactive')});
          notyf.success($t("FilesData.NotyfFileRemoved"));
        } catch (e) {
          notyf.error($t("FilesData.NotyfErrorRemoveFile"));
        }
      }
    },

    async reactivate(fileData: any, $t: any) {
      if (confirm($t('FilesData.ConfirmReactivateFile'))) {
        if (fileData.file_id !== 0) {
          await this.saveFileToBeReactivated(fileData.file_id);
        }
        try {
          await this.reactivateFileEditedAppointment({file_pos: fileData.file_pos, status: $t('FilesData.TK_Active')});
          notyf.success($t("FilesData.NotyfFileReactivated"));
        } catch (e) {
          notyf.error($t("FilesData.NotyfErrorReactivateFile"));
        }
      }
    },

    formatFileSize(size: number) {
      if (size < 1024) return `${size} B`;
      if (size < 1048576) return `${(size / 1024).toFixed(1)} KB`;
      return `${(size / 1048576).toFixed(1)} MB`;
    }
  },

  mounted() {
    console.log("Mounted AppointmentDataFileTableRow");
  }
});
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
.sticky-column {
  position: sticky;
  max-width: 150px;
  left: 0;
  background: #fff;
  z-index: 2;
  border-right: 1px solid #ddd;
  border-left: 1px solid #ddd;
  will-change: left;
  display: block;
  word-break: break-word;
  overflow-wrap: anywhere;
}
.inactive-status {
  color: #a00;
  font-weight: bold;
}
</style>
